
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Alert from 'vux/src/components/alert/index.vue'

import store from '../../vuex/store'
import { go } from '../../libs/router'
import wx from 'weixin-js-sdk'
export default {
components: {
XInput,
XButton,
Group,
Cell,
Flexbox,
FlexboxItem,
Alert
},
data () {
return {
qrCode: '',
invoiceId: '',
dataDetail: {
invoiceBaseInfo: {
}
},
type: '',
wxReady: false,
localIds: [],
imgIds: [],
warnMsgShow: false,
warnMsg: '',
toastShow: false,
toastMsg: '',
invoiceQrcode: 0,
invoiceImagePath: 0,
regist: {},
borderClass: 'weui-fpbj2',
win: {},
imgUrl: '',
hrefStr: '',
adId: ''
}
},
mounted () {
let ADFun = setInterval( () => {
if ( window.ADImgUrl ) {
this.win = window
clearInterval( ADFun )
}
}, 300 )
















document.getElementById( 'hdgg_entrance_element1' ).style.display = 'block'
store.commit( 'UPDATE_TITLE', '票通云' )
this.getAdPromotion();
},












computed: {
isShowInster () {
return this.dataDetail.invoiceBaseInfo.invoiceAmount > 0 && this.dataDetail.isInsert == false && this.dataDetail.insertByOther == false;
}
},
destroyed () {
document.getElementById( 'hdgg_entrance_element1' ).style.display = 'none'
},



created () {
store.commit( 'UPDATE_SHOW_FOOTER', false )
var _this = this
_this.invoiceId = ( _this.$route.params.id || '' )
var param = {
id: ( _this.invoiceId || '' )
}
_this.$ajax.post( _this.ajaxFactory.get( 'showInvoiceDetail' ), {}, { params: param } ).then( function ( response ) {
var result = response.data;
if ( result.code === '200' ) {
_this.dataDetail = result;

if ( _this.dataDetail.invoiceBaseInfo.invoiceKind === '10' || _this.dataDetail.invoiceBaseInfo.invoiceKind === '9'
|| _this.dataDetail.invoiceBaseInfo.invoiceKind === '08' || _this.dataDetail.invoiceBaseInfo.invoiceKind === '81'
|| _this.dataDetail.invoiceBaseInfo.invoiceKind === '82' ) {
_this.borderClass = 'weui-fpbj'
}
if ( result.invoiceQrcode ) {
_this.invoiceQrcode = result.invoiceQrcode
}

if ( result.invoiceImagePath ) {
_this.invoiceImagePath = result.invoiceImagePath
}
var isRed = false
if ( _this.dataDetail.invoiceBaseInfo.invoiceTotalAmount < 0 ) {
isRed = true
}
for ( var i = 0; i < _this.dataDetail.invoiceValueDetails.length; i++ ) {
if ( ( isRed && _this.dataDetail.invoiceValueDetails[i].money > 0 ) ||
( !isRed && _this.dataDetail.invoiceValueDetails[i].money < 0 ) ) {
_this.dataDetail.invoiceValueDetails[i].isZk = true
} else {
_this.dataDetail.invoiceValueDetails[i].isZk = false
}
}
if ( result.type === '01' ) {
_this.type = '增值税专用发票'
} else if ( result.type === '02' ) {
_this.type = '货运运输业增值税专用发票'
} else if ( result.type === '03' ) {
_this.type = '机动车销售统一发票'
} else if ( result.type === '04' ) {
_this.type = '增值税普通发票'
} else if ( result.type === '10' ) {
_this.type = '增值税电子发票（电子）'
} else if ( result.type === '11' ) {
_this.type = '增值税电子发票（卷式）'
} else if ( result.type === '9' ) {
_this.type = '区块链电子发票'
} else if ( result.type === '08' ) {
_this.type = '增值税电子专用发票'
} else if ( result.type === '81' ) {
_this.type = '电子发票（普通发票）'
} else if ( result.type === '82' ) {
_this.type = '电子发票（增值税专用发票）'
} else {
_this.type = '增值税电子发票'
}
} else {
_this.warnMsgShow = true
_this.warnMsg = result.msg
}
} ).catch( function ( response ) {
console.log( response )
} );
},
methods: {

getAdPromotion () {
var _this = this;
_this.$ajax.post( _this.ajaxFactory.get( 'getAdPromotion' ), {}, {
params: { adPosition: '4' }
} ).then( ( { data } ) => {
if ( data.code == 200 ) {
this.hrefStr = data.data.href;
this.imgUrl = data.data.imgUrl;
this.adId = data.data.id;
}
} )
},

adPromotioClick () {
var _this = this;
_this.$ajax.post( _this.ajaxFactory.get( 'countAdHits' ), {}, {
params: { id: _this.adId }
} ).then( ( res ) => { } );
},

onClick ( type ) {

let link = '/fpjdetail/' + this.dataDetail.source + '/' + this.dataDetail.imgSize + '/' +
encodeURIComponent( this.invoiceQrcode ) + '/' + this.invoiceImagePath + '/' +
( this.invoiceId || '' ) + '/' + this.dataDetail.invoiceBaseInfo.invoiceKind;

if ( type == 'fpPaiZhao' )
link = '/scptfp/' + this.dataDetail.invoiceBaseInfo.id;

if ( type == 'jxFiles' )
link = '/fpjdetail/' + this.dataDetail.source + '/' + this.dataDetail.imgSize + '/' +
this.invoiceQrcode + '/' + this.invoiceImagePath + '/1/1';

this.$router.push( link + '?taxpayerNum' + this.dataDetail.taxpayerNum )
},
importWxCard () {
var _this = this
var url = location.href.split( '#' )[0]
if ( typeof ( _this.dataDetail.isInsert ) === undefined || _this.dataDetail.isInsert === false ) {
_this.$ajax.post( _this.ajaxFactory.get( 'insertCard' ), {}, {
params: {
invoiceCode: _this.dataDetail.invoiceBaseInfo.invoiceCode,
invoiceNo: _this.dataDetail.invoiceBaseInfo.invoiceNo,
url: url
}
} ).then( function ( response ) {
window.location.href = response.data.auth_url
} ).catch( function ( response ) {
alert( "error:" + JSON.stringify( response ) )
} )
} else {
_this.warnMsgShow = true
_this.warnMsg = '该发票已导入卡包'
}
},
viewWxCard () {
var _this = this
wx.openCard( {
cardList: [{
cardId: _this.dataDetail.viewCard.cardId,
code: _this.dataDetail.viewCard.code
}]
} )
}
}
}



// WEBPACK FOOTER //
// ./src/components/fpj/dzfppz.vue